import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useSearchBarStyles = makeStyles((theme: Theme) => ({
	root: {
		position: 'relative',
	},
	searchContainer: {
		alignItems: 'center',
		backgroundColor: 'white',
		borderRadius: 6,
		boxShadow: '0px 3px 6px #00000029',
		display: 'flex',
		padding: '7px 16px',
		position: 'relative',
		zIndex: 2,
	},
	inputContainer: {
		alignItems: 'center',
		display: 'flex',
		flexFlow: 'row wrap',
		height: '100%',
	},
	searchIcon: {
		color: '#707070',
		height: 18,
		marginRight: 8,
		width: 18,
	},
	searchInput: {
		border: 'none',
		color: '#707070',
		fontFamily: 'Montserrat',
		fontSize: 14,
		fontWeight: 400,
		height: 18,
		outline: 'none',
		width: 399,
		[theme.breakpoints.down('lg')]: {
			width: '160px',
		},
	},
	divider: {
		backgroundColor: '#707070',
		height: 18,
		margin: `0 12px`,
		width: '1px',
	},
	resultsContainer: {
		backgroundColor: 'white',
		borderRadius: '0 0 13px 13px',
		boxShadow: '0px 3px 6px #00000029',
		color: '#707070',
		left: 0,
		overflow: 'hidden',
		paddingBottom: 16,
		paddingTop: 22.5,
		position: 'absolute',
		top: 'calc(100% - 6.5px)',
		transition: '.4s max-height ease-in-out',
		width: '100%',
		zIndex: 1,
	},
	dataContainer: {
		alignItems: 'center',
		display: 'flex',
		flexFlow: 'row wrap',
		gap: 16,
		padding: '8px 24px',
	},
	dataContainerClickable: {
		borderRadius: 6,
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: '#F7F5F5',
		},
	},
	dataContainerIcon: {
		color: '#bababa',
		height: 24,
		width: 24,
	},
}));

export default useSearchBarStyles;
